('use strict');

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JSX Modules
import CustomUniversalSelect from '../_utils/custom-universal-select';

// -----------------------------------------------------------
//  Sort
// -----------------------------------------------------------

const options = [{
  value: 'best-sellers',
  label: 'Best sellers'
}, {
  value: 'price-low-to-high',
  label: 'Price: low to high'
}, {
  value: 'price-high-to-low',
  label: 'Price: high to low'
}, {
  value: 'new',
  label: 'New'
}, {
  value: 'featured',
  label: 'Featured'
}];

const Sort = ({ value, onChange }) => {
  const ariaLabel = options.find(option => option.value === value)?.label || options[0].label;

  return (
    <form
      className='form-inline sort'>
      <div className="form-group">
        <label htmlFor="sort-select" aria-label={`Sort by ${ariaLabel}`}>
          Sort by&nbsp;&nbsp;|
        </label>
          <CustomUniversalSelect
            ariaLabel="Sort by"
            options={options}
            value={value}
            onChange={onChange}
          />
      </div>
    </form>
  );
};

Sort.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default Sort;
